import { gql } from '@apollo/client';
import { SaleItemPackageListFragment } from '../fragments/SaleItemPackageListFragment';
/**
 * @const SaleItemPackageListQuery
 * @since 1.0.0
 */
export const SaleItemPackageListQuery = gql `
  query SaleItemPackageListQuery($input: SaleItemPackagesInput) {
    saleItemPackages(input: $input) {
      items {
        ...SaleItemPackageListFragment
      }
      count
    }
  }

  ${SaleItemPackageListFragment}
`;
